'use client';
import {
  createPortableDialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import { LoginDialog } from '@wwe-portal/ui/features/auth/login-dialog';
import { FacebookLogin } from './facebook-login';
import { ScopelyLogin } from './scopely-login';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { ReactNode, useEffect } from 'react';

const WWELoginDialog = (props: { title: ReactNode }) => {
  const modal = usePortableDialog();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated && modal.visible) modal.remove();
  }, [isAuthenticated]);
  return (
    <LoginDialog
      title={props.title}
      open={modal.visible}
      onClose={modal.remove}
      loginButtons={
        <>
          <FacebookLogin />
          <ScopelyLogin />
        </>
      }
    />
  );
};

export const LoginDialogPortable = createPortableDialog(WWELoginDialog);
